import {Button, List, SimpleGrid, Stack, Title} from "@mantine/core";
import {Link, useParams} from "react-router";
import '@mantine/core/styles.css';
import "./index.css";
import {Timer} from "./timer.tsx";
import {CustomCard} from "./card.tsx";
import {IconArrowLeft} from "@tabler/icons-react";

const warmUpItems = [
  'Arm circles',
  'Torso twists',
  'Hip circles',
  'Bodyweight squats',
  'High knees',
  'Lunges with reach',
]

const coolDownItems = [
  'Chest stretch',
  'Cross-body shoulder stretch',
  'Overhead triceps stretch',
  'Seated hamstring stretch',
  'Standing quad stretch',
  'Cat-cow stretch',
]

const exercises = {
  push: {
    label: 'Upper body push',
    items: [
      'Dumbbell bench',
      'Overhead shoulder press',
      'Lateral raises',
      'Overhead triceps extension',
      'Push-ups',
    ],
  },
  core: {
    label: 'Lower body + core',
    items: [
      'Goblet squats',
      'Romanian deadlifts',
      'Dumbbell lunges',
      'Russian twists',
      'Plank hold',
    ]
  },
  pull: {
    label: 'Upper body pull',
    items: [
      'Bent-over dumbbell rows',
      'Reverse flys',
      'Bicep curls',
      'Hammer curls',
      'Renegade rows',
    ],
  },
}

export type ExerciseType = keyof typeof exercises

export function ExerciseInfo() {
  const {exercise} = useParams<{ exercise: ExerciseType }>()

  const exerciseInfo = exercises[exercise]

  return (
    <Stack>
      <Title>
        <Link to="/">
          <Button size="xs" mr="xs" variant="subtle">
            <IconArrowLeft/>
          </Button>
        </Link>
        {exerciseInfo.label}
      </Title>

      <SimpleGrid cols={{base: 1, xs: 3}} spacing="md">
        <ExerciseItemsCard label="Warm-up" items={warmUpItems}/>
        <ExerciseItemsCard label="Main" items={exerciseInfo.items}/>
        <ExerciseItemsCard label="Cooldown" items={coolDownItems}/>
      </SimpleGrid>

      <Timer/>
    </Stack>
  )
}


function ExerciseItemsCard({label, items}: { label: string; items: string[] }) {
  return (
    <CustomCard label={label}>
      <List>
        {items.map((item, index) => (
          <List.Item key={index}>{item}</List.Item>
        ))}
      </List>
    </CustomCard>
  )
}
